
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ required: true }) name!: string;
}
